import {useId} from 'react';

export function useRichTextKey() {
  const baseId = useId();
  let index = 0;

  return () => {
    const key = `${baseId}-${index}`;
    index += 1;
    return key;
  };
}
